class Sutikezeles {

    showAdatvedelem(state)
    {
        if (state == 'on')
        {

            $('.super-popup.gdpr').removeClass('condensed');
            $('.super-popup.gdpr .uzenet').addClass('hide');
            $('.super-popup.gdpr .adatvedelem').removeClass('hide');
            $('.super-popup.gdpr .butt-on').addClass('hide');
            $('.super-popup.gdpr .butt-off').removeClass('hide');

            setTimeout(function () {
                if ($('.super-popup.gdpr .adatvedelem a#cookie').length > 0)
                {
                    $('.super-popup.gdpr .adatvedelem').get(0).scrollTop = ($('.super-popup.gdpr .adatvedelem a#cookie').position().top - 80);
                }
            }, 200)

        } else if (state == 'off') {
            $('.super-popup.gdpr').addClass('condensed');
            $('.super-popup.gdpr .uzenet').removeClass('hide');
            $('.super-popup.gdpr .adatvedelem').get(0).scrollTop = 0;
            $('.super-popup.gdpr .adatvedelem').addClass('hide');
            $('.super-popup.gdpr .butt-on').removeClass('hide');
            $('.super-popup.gdpr .butt-off').addClass('hide');
        }

    }

    elfogadas()
    {
        var diszt = $('html').data('disztributor');

        $('.super-popup, .super-popup-layer').remove();

        if (document.cookie.indexOf(diszt+"-gdpr-accepted") == -1){
            var egyev = new Date(new Date().getTime()+(3600*24*365*1000));
            document.cookie = diszt + "-gdpr-accepted=" + egyev.getTime() + "; expires=" + egyev.toGMTString();

            window.dataLayer.push({
                'event': 'consent_update',
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'ad_personalization': 'granted'
            });


            // window.dataLayer = window.dataLayer || [];
            // function gtag(){dataLayer.push(arguments);}
            // gtag('js', new Date());

            // gtag('config', 'G-C9ZRWQYX3C');

            // gtag('consent', 'update', {
            //     ad_user_data: 'granted',
            //     ad_personalization: 'granted',
            //     ad_storage: 'granted',
            //     analytics_storage: 'granted'
            // });


        }

        window.location.reload();
    }

    clearAll() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {

            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            name = name.trim()
            if (name.indexOf('_g') > -1 || name.indexOf('__utm') > -1)
            {
                Cookies.remove(name);
                Cookies.remove(name, { path: '/' });
                Cookies.remove(name, { path: '/', domain: '.podoroele.de' });
                Cookies.remove(name, { path: '/', domain: document.domain });
            }
        }
    }
}

export default Sutikezeles;
